import { MenuItemProps, MenuItem } from '@mui/material';
import { styled } from '@mui/material/styles';

export const MenuItemStyled = styled(MenuItem)<MenuItemProps>(({ theme }) => ({
  '&.MuiMenuItem-root': {
    color: theme.palette.tertiary.main,
    padding: `${theme.spacing(0.5)} ${theme.spacing(2)}`,
  },
  '&.MuiMenuItem-root:hover': {
    backgroundColor: 'rgba(17, 17, 19, 0.04)',
  },
  '&.MuiMenuItem-root.Mui-selected': {
    backgroundColor: 'rgba(17, 17, 19, 0.08)',
    fontWeight: '600',
  },
}));
